// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 10304-订单取消 取消订单 GET /web/v1/order/cancel/${param0} */
export async function cancelOrder(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.cancelOrderParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/order/cancel/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 10303-订单详情查询 根据订单ID查询订单详情 GET /web/v1/order/detail/${param0} */
export async function getOrderDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getOrderDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimOrderDetailVo>(
    `/web/v1/order/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 10302-订单列表查询 分页查询订单列表 POST /web/v1/order/list */
export async function getOrderList(
  body: API.SwimOrderListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimOrderListVo>(
    "/web/v1/order/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10301-线下售票 线下售票（支持会员和非会员） POST /web/v1/order/offline/ticket */
export async function offlineTicket(
  body: API.SwimOrderOfflineTicketVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimOrderOfflineTicketRespVo>(
    "/web/v1/order/offline/ticket",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10305-订单退款 订单级退款：仅允许已支付订单退款，退款金额不能大于已支付金额 POST /web/v1/order/refund/${param0} */
export async function refundOrder(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.refundOrderParams,
  body: API.SwimOrderRefundVo,
  options?: { [key: string]: any }
) {
  const { orderId: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/order/refund/${param0}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}
